import { makeStyles } from "@material-ui/core/styles"
import React from "react"
import { withRouter } from "react-router-dom"

const Conteudo = (props) => {
	const classes = useStyles()

	return (
		<div className={props.temMenuLateral ? [classes.content, classes.menuLateral].join(" ") : classes.content}>
			{ props.temToolbar && <div className={classes.toolbar} />}
			{props.conteudo}
		</div>
	)
}

const drawerWidth = 81
const useStyles = makeStyles((theme) => ({
	toolbar: theme.mixins.toolbar,
	content: {
		flexGrow: 1,
		backgroundColor: "#FFFFFF",
		paddingBottom: "0",
		minHeight: "100vh",
	},
	menuLateral: {
		marginLeft: drawerWidth,
	},
}))

export default withRouter((props) => <Conteudo {...props} />)
